// mock t function for i18next scanner to pick up
const t = (x: string) => x

export enum FilterGueltigkeit {
    AllWkz = 0,
    AktMonth = 1,
    WkzGueltigZum = 2,
}

export const FilterGueltigkeitLabels: {[k: string]: string} = {
    [FilterGueltigkeit.AllWkz]: t('ix2044:enum.FilterGueltigkeit.AllWkz'),
    [FilterGueltigkeit.AktMonth]: t('ix2044:enum.FilterGueltigkeit.AktMonth'),
    [FilterGueltigkeit.WkzGueltigZum]: t('ix2044:enum.FilterGueltigkeit.WkzGueltigZum'),
}

export const filterGueltigkeitToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in FilterGueltigkeit) {
        if (!isNaN(Number(x))) { continue }


        opts.push({
            name: t(FilterGueltigkeitLabels[FilterGueltigkeit[x as keyof typeof FilterGueltigkeit]]),
            value: FilterGueltigkeit[x as keyof typeof FilterGueltigkeit],
        })
    }

    return opts
}
